import { render } from "./Campaigns.vue?vue&type=template&id=5dc8e89a&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"

import "./custom-campaigns.scss?vue&type=style&index=0&id=5dc8e89a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc8e89a"]])

export default __exports__